import { Routes } from '@angular/router';
import { EntitiesComponent } from '@components/administration/entities/entities.component';
import { OfficeComponent } from '@components/administration/offices/office.component';
import { GroupComponent } from '@components/administration/groups/groups.component';
import { CertProTemplateComponent } from '@components/administration/certpro/certpro.component';
import { CertproEvaluateComponent } from '@components/certpro/evaluate/evaluate.component';
import { CertproRecordsComponent } from '@components/certpro/record/record.component';
import { UsersManagementComponent } from '@components/user/users-management/users-management.component';
import { UserRolesComponent } from '@components/user/roles/roles.component';
import { MenusComponent } from '@components/user/menus/menus.component';
import { authGuard } from '@guards/auth.guard';

export const routes: Routes = [
    {
        path: 'admin',
        canActivate: [authGuard],
        children: [
            {
                path: 'entidades',
                component: EntitiesComponent
            },
            {
                path: 'grupos',
                component: GroupComponent
            },
            {
                path: 'campos',
                component: OfficeComponent
            },
            {
                path: 'cerpro',
                component: CertProTemplateComponent
            },
            {
                path: 'usuarios',
                component: UsersManagementComponent
            },
            {
                path: 'roles',
                component: UserRolesComponent
            },
            {
                path: 'menus',
                component: MenusComponent
            }
        ]
    },
    {
        path: 'cerpro',
        canActivate: [authGuard],
        component: CertproEvaluateComponent
    },
    {
        path: 'historial',
        canActivate: [authGuard],
        component: CertproRecordsComponent
    }
];
